import { Edit2, Trash2 } from 'lucide-react';

const CardSelector = ({
    card,
    selectedCardId,
    onSelect,
    onEdit,
    onDelete,
    className = '',
    variant = 'default',
}) => {
    const BASE_CARD_ICON_URL = 'https://images.halalfull.com/assets/img/icon/cc/';
    const imageUrl = card.card_type
        ? `${BASE_CARD_ICON_URL}${card.card_type.toLowerCase()}.svg`
        : `${BASE_CARD_ICON_URL}default.svg`;

    const styleMap = {
        default: {
            text: 'text-gray-700',
            subText: 'text-gray-500',
            border: 'border-primary-100',
            hoverBg: 'hover:bg-primary-100',
            hoverText: 'hover:text-white',
            iconColor: 'text-primary-100',
            trashColor: 'text-primary-400',
        },
        light: {
            text: 'text-white',
            subText: 'text-white',
            border: 'border-white',
            iconColor: 'text-white',
            trashColor: 'text-white',
        },
        dark: {
            text: 'text-black',
            subText: 'text-gray-700',
            border: 'border-black',
            hoverBg: 'hover:bg-black',
            hoverText: 'hover:text-white',
            iconColor: 'text-black',
            trashColor: 'text-black/70',
        },
    };

    const styles = styleMap[variant] || styleMap.default;

    // Handle edit button click
    const handleEditClick = (e) => {
        e.preventDefault(); // Prevent radio button selection
        e.stopPropagation(); // Stop event bubbling
        onEdit(card); // Pass the entire card object
    };

    // Handle delete button click
    const handleDeleteClick = (e) => {
        e.preventDefault(); // Prevent radio button selection
        e.stopPropagation(); // Stop event bubbling
        onDelete(card);
    };

    return (
        <div key={card.payment_id} className={`rounded-lg px-5 py-2 ${className}`}>
            <label className='flex items-center gap-4 cursor-pointer relative'>
                <input
                    type='radio'
                    name='cardSelect'
                    value={card.payment_id}
                    checked={selectedCardId === card.payment_id}
                    onChange={() => onSelect(card.payment_id)}
                    className={`w-5 h-5`}
                />

                <div className='flex items-center gap-3 flex-1'>
                    <div>
                        <div className='flex items-center gap-2'>
                            <img src={imageUrl} alt='card' className='w-12 h-10' />
                            <span className={`font-normal letter-spacing-2 ${styles.text}`}>
                                ********{card?.card_number}
                            </span>
                        </div>

                        <div className={`flex items-center ${styles.subText} space-x-3`}>
                            <h2 className='font-normal text-sm letter-spacing-07'>
                                {card.card_holder_name}
                            </h2>
                            <p className='font-normal text-sm letter-spacing-07'>
                                {card.card_expiry_date}
                            </p>
                        </div>
                    </div>
                </div>

                <div className={`flex items-center gap-5`}>
                    <button
                        type='button'
                        onClick={handleEditClick}
                        className={`p-1 rounded-full md:border md:border-gray-500 hover:bg-gray-100 transition-colors`}
                        title='Edit card'
                    >
                        <Edit2 className={`md:h-6 md:w-6 md:p-1 p-0 h-4 w-4 md:text-gray-500`} />
                    </button>
                    <button
                        type='button'
                        onClick={handleDeleteClick}
                        className={`p-1 md:border md:border-primary-100 rounded-full hover:bg-red-50 transition-colors`}
                        title='Delete card'
                    >
                        <Trash2
                            className={`md:h-6 md:w-6 md:p-1 md:text-primary-100 p-0 h-4 w-4`}
                        />
                    </button>
                </div>
            </label>
        </div>
    );
};

export default CardSelector;
